module.exports = __webpack_public_path__ + "static/media/semuEmployeeCodeSample.7092fbbc.xls";